export const CONNECTOR_LABEL = {
  quarter_inch_ts: '1/4" TS',
  quarter_inch_trs: '1/4" TRS',
  eighth_inch_ts: '1/8" TS (3.5mm)',
  eighth_inch_trs: '1/8" TRS (3.5mm)',
  eighth_inch_trrs: '1/8" TRRS (3.5mm)',
  xlr: "XLR",
  xlr_combo: "XLR Combo",
  speakon: "Speakon",
  midi_din: "MIDI DIN",
  usb_a: "USB-A",
  usb_b: "USB-B",
  usb_c: "USB-C",
  barrel_2_1mm: "2.1mm Barrel",
  barrel_2_5mm: "2.5mm Barrel",
  rca: "RCA",
  proprietary: "Proprietary",
  mini_xlr_3pin: "Mini-XLR 3-pin (TA3F)",
  mini_xlr_4pin: "Mini-XLR 4-pin (TA4F)",
  ultranet: "Ultranet",
  wireless: "Wireless",
  ethernet: "Ethernet",
  ethercon: "EtherCon",
  thunderbolt: "Thunderbolt",
  usb_b_mini: "USB-B Mini",
  usb_b_micro: "USB-B Micro",
  toslink: "Toslink",
  bnc: "BNC",
  db25: "DB-25",
  tt: "TT (Bantam)",
};

export const SIGNAL_LEVEL_LABEL = {
  mic: "Mic",
  instrument: "Instrument",
  line: "Line",
  mic_line: "Mic/Line",
  speaker: "Speaker",
};

export const SIGNAL_TYPE_LABEL = {
  audio: "Audio",
  control: "Control",
  midi: "MIDI",
  usb_audio: "USB Audio",
  cv: "CV",
  thunderbolt_audio: "Thunderbolt Audio",
  network_audio: "Network Audio",
  adat: "ADAT",
  spdif: "S/PDIF",
  aes: "AES/EBU",
};

export const PHANTOM_POWER_LABEL = {
  required: "Required",
  accepted: "Accepted",
  not_allowed: "Not Allowed",
};

// Short connector labels for connectors whose family name is too vague
// to tell you what cable to use (e.g., "USB" could be A/B/C). When set,
// this label can replace a generic port name on the canvas.
const DISAMBIGUATING_CONNECTOR_LABEL = {
  usb_a: "USB-A",
  usb_b: "USB-B",
  usb_c: "USB-C",
  usb_b_mini: "USB-B Mini",
  usb_b_micro: "USB-B Micro",
  mini_xlr_3pin: "TA3F",
  mini_xlr_4pin: "TA4F",
  barrel_2_1mm: "2.1mm",
  barrel_2_5mm: "2.5mm",
};

// Port names considered "generic enough to replace" for a given connector
// family. Numbered names like "USB 1", "DC Out 4" are NOT in this list,
// because the numbering carries info the user needs. Side of the device
// node tells you input vs output, so "Input"/"Output" can be replaced.
const REPLACEABLE_GENERIC_NAMES = {
  usb: ["usb"],
  mini_xlr: ["input", "output"],
};

export function disambiguatingConnectorLabel(connector) {
  return DISAMBIGUATING_CONNECTOR_LABEL[connector] || null;
}

// Returns the label to render for a port: the disambiguating connector tag
// if the port has a generic-family name (e.g., "USB" → "USB-C"), otherwise
// the port name as-is.
export function portDisplayLabel(port) {
  if (!port?.name) return port?.name || "";
  const tag = disambiguatingConnectorLabel(port.connector);
  if (!tag) return port.name;

  let family = null;
  if (port.connector?.startsWith("usb")) family = "usb";
  else if (port.connector?.startsWith("mini_xlr")) family = "mini_xlr";

  const generic = family ? REPLACEABLE_GENERIC_NAMES[family] || [] : [];
  if (generic.includes(port.name.trim().toLowerCase())) return tag;
  return port.name;
}
